import { ControlApiError } from "@/lib/api/client";

export function formatTimestamp(iso: string | undefined): string {
  if (!iso) {return "—";}
  try {
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

export function formatRelativeTime(iso: string | undefined): string {
  if (!iso) {return "—";}
  const diff = Date.now() - new Date(iso).getTime();
  const seconds = Math.floor(diff / 1000);
  if (seconds < 60) {return "just now";}
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {return `${minutes}m ago`;}
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {return `${hours}h ago`;}
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

export function truncateId(id: string, length = 12): string {
  if (id.length <= length) {return id;}
  return id.slice(0, length) + "...";
}

export function toastMutationError(err: unknown, fallback = "Operation failed") {
  if (err instanceof ControlApiError) {
    const body = err.body as Record<string, unknown> | null;
    const nestedError = body?.error as Record<string, unknown> | undefined;
    const message = body?.message ?? nestedError?.message ?? body?.error ?? err.message;
    return String(message);
  }
  if (err instanceof Error) {
    return err.message;
  }
  return fallback;
}
